interface GroupedResult<T> {
	[key: string]: T[];
}

export const groupBy = <T>(items: T[], key: keyof T): GroupedResult<T> => {
	return items.reduce(function (accumulator: GroupedResult<T>, item: T) {
		(accumulator[item[key] as string] ??= []).push(item);
		return accumulator;
	}, {} as GroupedResult<T>);
};

export const clampNumber = (value: string, min = 0, max = 100): number => {
	const num = Number(value);
	if (isNaN(num)) return min;
	return Math.max(min, Math.min(max, num));
};
